import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { GameScene, FactionSide, MapConfig } from '@/core/types/global.types';

const generateSeed = () => Math.random().toString(36).substring(2, 9).toUpperCase();

interface GlobalState {
    currentScene: GameScene;
    playerSide: FactionSide;
    mapConfig: MapConfig;
    setScene: (scene: GameScene) => void;
    setPlayerSide: (side: FactionSide) => void;
    setMapConfig: (config: MapConfig) => void;
    changeScene: (scene: GameScene) => Promise<void>;
    setChangeSceneFn: (fn: (scene: GameScene) => Promise<void>) => void;
}

const DEFAULT_MAP_CONFIG: MapConfig = {
    size: 24,
    seed: generateSeed(),
    hillChance: 3,
    obstacleChance: 5,
    playerUnits: [
        { id: `druzhynnyk_${crypto.randomUUID()}`, unitId: 'druzhynnyk', count: 2 },
        { id: `striletz_${crypto.randomUUID()}`,   unitId: 'striletz',   count: 3 },
        { id: `gryd_${crypto.randomUUID()}`,       unitId: 'gryd',       count: 2 },
        { id: `varangian_${crypto.randomUUID()}`,  unitId: 'varangian',  count: 3 },
    ],
    enemyUnits: [
        { id: `bek_${crypto.randomUUID()}`,     unitId: 'bek',     count: 3 },
        { id: `kipchak_${crypto.randomUUID()}`, unitId: 'kipchak', count: 3 },
        { id: `batyr_${crypto.randomUUID()}`,   unitId: 'batyr',   count: 2 },
        { id: `batyr_${crypto.randomUUID()}`,   unitId: 'batyr',   count: 2 },
    ],
};

const getInitialState = () => ({
    // currentScene: GameScene.WORLD,
    currentScene: GameScene.CITY,
    playerSide: FactionSide.RUTHENIA,
    mapConfig: DEFAULT_MAP_CONFIG,
});


export const useGlobalStore = create<GlobalState>()(
    subscribeWithSelector((set) => ({
        ...getInitialState(),
        setScene: (scene) => set({ currentScene: scene }),
        setPlayerSide: (side) => set({ playerSide: side }),
        setMapConfig: (config) => set({ mapConfig: config }),
        changeScene: async () => { console.warn("Scene init function not ready") },
        setChangeSceneFn: (fn) => set({ changeScene: fn }),
    }))
);
